import Seo, { SEO_FRAGMENT } from '../../components/Seo';
import Hero, { HERO_FRAGMENT } from '../../components/Hero';
import BrandsIndex, { BRANDS_INDEX_FRAGMENT } from '../../components/BrandsIndex';
import fetchGql, { gql } from '../../util/fetchGql';

export default function Brands ({ entry: { seo, hero }, ...props }) {
	return (
		<>
			<Seo seo={seo} />
			<Hero {...hero[0]} />
			<BrandsIndex {...props} />
		</>
	);
}

export async function getStaticProps ({ params, ...ctx }) {
	const data = await fetchGql(gql`
        query GetBrands {
	        entry (slug: "brands") {
		        ... on brands_brands_Entry {
			        seo { ...Seo }
			        hero: banner { ...Hero }
		        }
	        }
            ...BrandsIndex
        }
        ${SEO_FRAGMENT}
        ${HERO_FRAGMENT}
        ${BRANDS_INDEX_FRAGMENT}
	`, null, ctx);

	return {
		props: {
			...data,
		},

	};
}
